import React from 'react'
import PropTypes from 'prop-types'
import Iconify from 'components/Iconify'
import { Box, Grid, Typography } from '@mui/material'
import TranslatableImage from '../../TranslatableImage'
import { Title, Content } from './style'

export default function Review({ color, reviews, alt }) {
  return (
    <Box sx={{ mb: 10 }}>
      <Title>
        <Iconify
          color={color}
          icon='akar-icons:chat-dots'
          style={{ fontSize: 23 }}
        />
        <Typography variant='h5' sx={{ ml: 1.5 }}>
          {'User reviews'}
        </Typography>
      </Title>
      <Content>
        <Grid container spacing={2}>
          {reviews.paths.map((path, index) => {
            return (
              <Grid key={index} item xs={reviews.xs}>
                <TranslatableImage
                  style={{ objectFit: 'contain', width: '100%' }}
                  alt={alt}
                  src={path}
                />
              </Grid>
            )
          })}
        </Grid>
      </Content>
    </Box>
  )
}

Review.propTypes = {
  color: PropTypes.string,
  reviews: PropTypes.array,
  alt: PropTypes.string,
}
